import { gql } from '../../../../../hooks'

export const DELETE_TYPES = gql`
  mutation AdministrationDeleteComponentTypes($id: ID!) {
    aDelete(path: "component/types", id: $id) {
    }
  }
`

export const LIST_TYPES = gql`
  query AdministrationListComponentTypes(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/types"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
